import {
  IconButton as ChakraIconButton,
  IconButtonProps as ChakraIconButtonProps,
} from '@chakra-ui/react'
import { forwardRef } from '@chakra-ui/react'
import { SwashbuckleComponentProps, SemanticColorSchemes } from '../../types'

type IconButtonProps = {
  colorScheme?: SemanticColorSchemes
} & Omit<SwashbuckleComponentProps<ChakraIconButtonProps>, 'isRound'>

export const IconButton = forwardRef(
  ({ 'data-qa': dataQa, className, ...chakraProps }: IconButtonProps, ref) => {
    return (
      <ChakraIconButton
        ref={ref}
        data-qa={dataQa}
        className={className}
        title={chakraProps.title ?? chakraProps['aria-label']}
        {...chakraProps}
      />
    )
  }
)

IconButton.displayName = 'IconButton'
